import { render } from "./SAWelcome.vue?vue&type=template&id=f1d3cdde&scoped=true&ts=true"
import script from "./SAWelcome.vue?vue&type=script&lang=ts"
export * from "./SAWelcome.vue?vue&type=script&lang=ts"

import "./SAWelcome.vue?vue&type=style&index=0&id=f1d3cdde&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d3cdde"]])

export default __exports__